import {
  //Action,
  ActionType
  // BookingInfo
} from '../model/model'
import bookingInfoApi from '../services/bookingInfoApi'
import keysToCamel from '../helpers/keysToCamel'

export const fetchLanguage = (
  langcode: String = 'en',
  page: String,
  group: String
) => async (dispatch: Function) => {
  dispatch({ type: ActionType.FETCHING_LANGUAGE })
  try {
    const { data } = await bookingInfoApi.get(
      `/translations2/${langcode}/${page}/${group}`
    )
    dispatch({
      type: ActionType.FETCH_LANGUAGE_SUCCESS,
      payload: keysToCamel(data)
    })
  } catch (error) {
    dispatch({
      type: ActionType.FETCH_LANGUAGE_FAIL,
      payload: error.response
    })
  }
}
